import { Bell } from 'lucide-react';
import Lottie from "lottie-react";
import ShimmerAnimation from "../_local/assets/images/ShimmerAnimation.json";

const ComingSoon = () => {
    return (
        <div className="flex flex-col items-center justify-center h-[70vh] text-center px-4 bg-white">
            <span className="bg-violet-100 text-violet-700 px-4 py-3 rounded-full text-xs font-manropeSB tracking-wide mb-4">
                Parental Insights
            </span>

            <p className="italic mb-2">
                Coming your way <span className="font-manropeB">before August 2025</span>
            </p>
            <div className="flex flex-col items-center justify-center mb-4 relative">
                <h1 className="text-5xl font-bold bg-gradient-to-r from-[#FD6767] via-[#E530AF] to-[#2D49D5] bg-clip-text text-transparent relative pb-2 z-[2]">
                    Coming Soon
                </h1>
                <div className='absolute bottom-0 left-0 w-full z-[1]'>
                    <div className="grid grid-cols-2">
                        <div style={{ transform: "scaleX(-1)" }}>
                            <Lottie animationData={ShimmerAnimation} />
                        </div>
                        <div style={{ transform: "scaleX(1)" }}>
                        <Lottie animationData={ShimmerAnimation} />
                        </div>
                    </div>
                </div>
            </div>
            <p className="max-w-xl text-sm sm:text-base mb-6">
                A space for parents to share feedback that shapes their child’s school journey.
                We take feedback <span className='font-manropeSB'>thrice a year, at quarterly, half yearly and annually.</span>
            </p>

            <button className="flex items-center gap-2 text-sm text-violet-600 hover:underline font-manropeB">
                <Bell size={18} />
                Notify Me
            </button>
        </div>
    );
};

export default ComingSoon;
